export type TestIdProps = {
  /** Maps to `data-testid` for e2e selectors */
  testId?: string;
};

export function testIdProps(testId?: string): { 'data-testid'?: string } {
  return testId ? { 'data-testid': testId } : {};
}
